import {
  COLLECTIONS,
  COLLECTIONS_REVIEW,
  COLLECTIONS_CARD,
  COLLECTIONS_BANK,
  COLLECTIONS_CONFIRMATION,

  NEW_PAYMENT,
  NEW_PAYMENT_REVIEW,
  NEW_PAYMENT_CARD,
  NEW_PAYMENT_BANK,
  NEW_PAYMENT_CONFIRMATION,
  AUTHENTICATION_REQUIRED,

  PAYMENT_PLAN,
  PAYMENT_PLAN_BANK,
  PAYMENT_PLAN_CARD,
  PAYMENT_PLAN_REVIEW,
  PAYMENT_PLAN_CONFIRMATION,

  ARRANGEMENT,
  ARRANGEMENT_NEW,
  ARRANGEMENT_SPLIT,
  ARRANGEMENT_SPLIT_NEW,
  ARRANGEMENT_REVIEW,
  ARRANGEMENT_CONFIRMATION,

  AUTOPAY,
  AUTOPAY_NEW_CARD,
  AUTOPAY_NEW_BANK,
  AUTOPAY_EDIT,
  AUTOPAY_EDIT_CONFIRM,

  METHODS,
  METHOD_NEW,
  METHOD_NEW_CARD,
  METHOD_NEW_BANK,
  METHOD_EDIT,

  HOME,
  SCHEDULED_PAYMENT,
  SCHEDULED_PAYMENT_EDIT,
  SCHEDULED_PAYMENT_REVIEW,
  SCHEDULED_PAYMENT_CONFIRM,
  SCHEDULED_PAYMENT_CANCEL_CONFIRM,

  PAYMENT_SETUP,

  TERMS_AUTOPAY,
  TERMS_STORED_PAYMENT,
  TERMS_ECOBILL,

  MOBILE_METHODS,
  MOBILE_METHOD_NEW,
  MOBILE_METHOD_NEW_CARD,
  MOBILE_METHOD_NEW_BANK,

  MOBILE_AUTOPAY,
  MOBILE_AUTOPAY_EDIT,
  MOBILE_AUTOPAY_EDIT_NEW_CARD,
  MOBILE_AUTOPAY_EDIT_NEW_BANK,
  MOBILE_AUTOPAY_EDIT_CONFIRM,

  MOBILE_NEW_PAYMENT,
  MOBILE_NEW_PAYMENT_CARD,
  MOBILE_NEW_PAYMENT_BANK,
  MOBILE_NEW_PAYMENT_METHOD,
  MOBILE_NEW_PAYMENT_REVIEW,
  MOBILE_NEW_PAYMENT_CONFIRMATION,

  MOBILE_DEVICE_NEW,
  MOBILE_DEVICE_NEW_CARD,
  MOBILE_DEVICE_NEW_BANK,
  MOBILE_DEVICE_NEW_REVIEW,
  MOBILE_DEVICE_NEW_CONFIRMATION,
  MOBILE_DEVICE_NEW_METHOD,
} from './routes';

import { getIsToday } from './date';

import impressionCache from './impressionCache';
import { randomId } from './uids';

const baseDigitalData = {
  schemaVersion: 0.11,
  page: {
    category: {
      primaryCategory: 'myaccount',
      subCategory1: 'billing',
      businessType: 'resi',
      siteType: 'selfservice',
      designType: 'responsive',
    },
    codebase: {
      name: 'my account payments',
      releaseVersion: '12/12/2018', // using release date for now
    },
    affiliate: {
      channel: 'web',
      name: 'comcast',
    },
    pageInfo: {
      language: 'en',
      attributes: {
        experience: 'web',
      },
    },
    attributes: {},
  },
  siteInfo: {
    sessionID: randomId().substring(0, 9)
               + randomId().substring(0, 9), // just random string
    // visitorID: 'TODO - use value from item 2 below'
  },
  user: [
    {
      profile: [{
        profileInfo: {
          customerType: 'existing',
          authenticationType: 'active authenticated',
          recognizationType: 'cookie recognized',
        },
      }],
    },
  ],
};

/**
 * Log all DTM calls to console.
 * @param enabled
 *  A local flag, e.g., `const enabled = getConfig().REACT_APP_DTMLOG === 'TRUE'`
 * @constructor
 */
export const DTM2Console = (enabled = false) => {
  if (enabled === true) {
    window.trackingDebug = true;
  }
};

export const getTrackingData = (
  macaroon = {},
  account = {},
  isHarness = false,
  crs = {},
) => {
  const digitalData = Object.assign({}, baseDigitalData);

  // Override the `experience: 'web'` flag to `native` when app is in harness.
  if (isHarness) {
    digitalData.page.pageInfo.attributes.experience = 'native';
  }
  if ('affiliate' in account) {
    digitalData.page.pageInfo.attributes.referrerId = account.affiliate;
  }
  if (macaroon.guid) {
    digitalData.user[0].profile[0].profileInfo = {
      ...digitalData.user[0].profile[0].profileInfo,
      userGUID: macaroon.guid,
      type: macaroon.mainAccountRoles.indexOf('PRIMARY') !== -1 ? 'primary' : 'SECONDARY',
    };
  }

  if (macaroon.mainAccountNumber) {
    const acct = (macaroon.accounts || []).find(acc => (
      acc.accountNumber === macaroon.mainAccountNumber
    ));
    if (acct) {
      digitalData.user[0].segment = {
        marketID: acct.accountNumber.substring(0, 8),
      };
      digitalData.user[0].profile[0].profileInfo = {
        ...digitalData.user[0].profile[0].profileInfo,
        preActivationState: 'Active',
        authGUID: acct.guid,
      };
    }
  }


  if (crs && crs.customerGuid) {
    digitalData.user[0].profile[0].profileInfo = {
      ...digitalData.user[0].profile[0].profileInfo,
      userGUID: crs.customerGuid,
      type: 'CONSENT',
      customerType: 'new',
    };
  }
  return digitalData;
};

export const addComponent = component => impressionCache.add(component);
export const setComponent = (id, component) => impressionCache.set(id, component);
export const flushComponentWithTimeout = (more) => {
  const flushPromise = impressionCache.flush(more);
  const timeout = new Promise(resolve => setTimeout(() => resolve([]), 200));
  return Promise.race([flushPromise, timeout]);
};

const screenList = {
  [NEW_PAYMENT]: 'payment',
  [NEW_PAYMENT_BANK]: 'new bank',
  [NEW_PAYMENT_CARD]: 'new card',
  [NEW_PAYMENT_REVIEW]: 'review',
  [NEW_PAYMENT_CONFIRMATION]: 'confirm',
  [AUTHENTICATION_REQUIRED]: 'auth-required',

  [COLLECTIONS]: 'collections',
  [COLLECTIONS_BANK]: 'new bank',
  [COLLECTIONS_CARD]: 'new card',
  [COLLECTIONS_REVIEW]: 'review',
  [COLLECTIONS_CONFIRMATION]: 'confirm',

  [PAYMENT_PLAN]: 'payment plan',
  [PAYMENT_PLAN_BANK]: 'new bank',
  [PAYMENT_PLAN_CARD]: 'new card',
  [PAYMENT_PLAN_REVIEW]: 'review',
  [PAYMENT_PLAN_CONFIRMATION]: 'confirm',

  [COLLECTIONS]: 'collections',
  [COLLECTIONS_BANK]: 'new bank',
  [COLLECTIONS_CARD]: 'new card',
  [COLLECTIONS_REVIEW]: 'review',
  [COLLECTIONS_CONFIRMATION]: 'confirm',

  [PAYMENT_PLAN]: 'payment plan',
  [PAYMENT_PLAN_BANK]: 'new bank',
  [PAYMENT_PLAN_CARD]: 'new card',
  [PAYMENT_PLAN_REVIEW]: 'review',
  [PAYMENT_PLAN_CONFIRMATION]: 'confirm',

  [ARRANGEMENT]: 'payment arrangement',
  [ARRANGEMENT_NEW]: 'new',
  [ARRANGEMENT_SPLIT]: 'split',
  [ARRANGEMENT_SPLIT_NEW]: 'split new',
  [ARRANGEMENT_REVIEW]: 'review',
  [ARRANGEMENT_CONFIRMATION]: 'confirm',

  [AUTOPAY]: 'autopay',
  [AUTOPAY_NEW_CARD]: 'new card',
  [AUTOPAY_NEW_BANK]: 'new bank',
  [AUTOPAY_EDIT]: 'edit',
  [AUTOPAY_EDIT_CONFIRM]: 'confirm',

  [METHODS]: 'methods',
  [METHOD_NEW]: 'new',
  [METHOD_NEW_CARD]: 'new card',
  [METHOD_NEW_BANK]: 'new bank',
  [METHOD_EDIT]: 'edit',

  [HOME]: 'scheduled payments',
  [SCHEDULED_PAYMENT]: 'scheduled payments',
  [SCHEDULED_PAYMENT_EDIT]: 'edit',
  [SCHEDULED_PAYMENT_REVIEW]: 'review',
  [SCHEDULED_PAYMENT_CONFIRM]: 'confirm',
  [SCHEDULED_PAYMENT_CANCEL_CONFIRM]: 'cancel confirmation',

  [TERMS_AUTOPAY]: 'autopay',
  [TERMS_STORED_PAYMENT]: 'stored payment',
  [TERMS_ECOBILL]: 'ecobill',

  [PAYMENT_SETUP]: 'billingsetupmodule',

  [MOBILE_METHODS]: 'mobile methods',
  [MOBILE_METHOD_NEW]: 'mobile new',
  [MOBILE_METHOD_NEW_CARD]: 'new card',
  [MOBILE_METHOD_NEW_BANK]: 'new bank',

  [MOBILE_AUTOPAY]: 'mobile autopay',
  [MOBILE_AUTOPAY_EDIT]: 'edit',
  [MOBILE_AUTOPAY_EDIT_NEW_CARD]: 'new card',
  [MOBILE_AUTOPAY_EDIT_NEW_BANK]: 'new bank',
  [MOBILE_AUTOPAY_EDIT_CONFIRM]: 'confirm',

  [MOBILE_NEW_PAYMENT]: 'mobile payment',
  [MOBILE_NEW_PAYMENT_CARD]: 'new card',
  [MOBILE_NEW_PAYMENT_BANK]: 'new bank',
  [MOBILE_NEW_PAYMENT_METHOD]: 'new method',
  [MOBILE_NEW_PAYMENT_REVIEW]: 'review',
  [MOBILE_NEW_PAYMENT_CONFIRMATION]: 'confirm',

  [MOBILE_DEVICE_NEW]: 'mobile device',
  [MOBILE_DEVICE_NEW_CARD]: 'new card',
  [MOBILE_DEVICE_NEW_BANK]: 'new bank',
  [MOBILE_DEVICE_NEW_METHOD]: 'new method',
  [MOBILE_DEVICE_NEW_REVIEW]: 'review',
  [MOBILE_DEVICE_NEW_CONFIRMATION]: 'confirm',
};

export const mapRouteToName = (match) => {
  if (!match || !match.path) {
    return false;
  }

  return screenList[match.url] || screenList[match.path] || match.path;
};

const categoryList = {
  [NEW_PAYMENT_BANK]: 'payment',
  [NEW_PAYMENT_CARD]: 'payment',
  [NEW_PAYMENT_REVIEW]: 'payment',
  [NEW_PAYMENT_CONFIRMATION]: 'payment',

  [COLLECTIONS_BANK]: 'collections',
  [COLLECTIONS_CARD]: 'collections',
  [COLLECTIONS_REVIEW]: 'collections',
  [COLLECTIONS_CONFIRMATION]: 'collections',

  [PAYMENT_PLAN_BANK]: 'xap',
  [PAYMENT_PLAN_CARD]: 'xap',
  [PAYMENT_PLAN_REVIEW]: 'xap',
  [PAYMENT_PLAN_CONFIRMATION]: 'xap',

  [ARRANGEMENT]: 'payment arrangement',
  [ARRANGEMENT_NEW]: 'payment arrangement',
  [ARRANGEMENT_SPLIT]: 'payment arrangement',
  [ARRANGEMENT_SPLIT_NEW]: 'payment arrangement',
  [ARRANGEMENT_REVIEW]: 'payment arrangement',
  [ARRANGEMENT_CONFIRMATION]: 'payment arrangement',

  [AUTOPAY_NEW_CARD]: 'autopay',
  [AUTOPAY_NEW_BANK]: 'autopay',
  [AUTOPAY_EDIT]: 'autopay',
  [AUTOPAY_EDIT_CONFIRM]: 'autopay',

  [METHOD_NEW]: 'methods',
  [METHOD_NEW_CARD]: 'methods',
  [METHOD_NEW_BANK]: 'methods',
  [METHOD_EDIT]: 'methods',

  [SCHEDULED_PAYMENT_EDIT]: 'scheduled payments',
  [SCHEDULED_PAYMENT_REVIEW]: 'scheduled payments',
  [SCHEDULED_PAYMENT_CONFIRM]: 'scheduled payments',
  [SCHEDULED_PAYMENT_CANCEL_CONFIRM]: 'scheduled payments',

  [TERMS_AUTOPAY]: 'terms',
  [TERMS_STORED_PAYMENT]: 'terms',
  [TERMS_ECOBILL]: 'terms',

  [PAYMENT_SETUP]: 'billing',

  [MOBILE_METHODS]: 'mobile methods',
  [MOBILE_METHOD_NEW]: 'mobile methods',
  [MOBILE_METHOD_NEW_CARD]: 'mobile methods',
  [MOBILE_METHOD_NEW_BANK]: 'mobile methods',

  [MOBILE_AUTOPAY_EDIT]: 'mobile autopay',
  [MOBILE_AUTOPAY_EDIT_NEW_CARD]: 'mobile autopay',
  [MOBILE_AUTOPAY_EDIT_NEW_BANK]: 'mobile autopay',
  [MOBILE_AUTOPAY_EDIT_CONFIRM]: 'mobile autopay',

  [MOBILE_NEW_PAYMENT_CARD]: 'mobile payment',
  [MOBILE_NEW_PAYMENT_BANK]: 'mobile payment',
  [MOBILE_NEW_PAYMENT_METHOD]: 'mobile payment',
  [MOBILE_NEW_PAYMENT_REVIEW]: 'mobile payment',
  [MOBILE_NEW_PAYMENT_CONFIRMATION]: 'mobile payment',

  [MOBILE_DEVICE_NEW_CARD]: 'mobile device',
  [MOBILE_DEVICE_NEW_BANK]: 'mobile device',
  [MOBILE_DEVICE_NEW_METHOD]: 'mobile device',
  [MOBILE_DEVICE_NEW_REVIEW]: 'mobile device',
  [MOBILE_DEVICE_NEW_CONFIRMATION]: 'mobile device',
};

export const mapRouteToSubCategory = (match) => {
  if (!match || !match.path) {
    return false;
  }

  return categoryList[match.url] || categoryList[match.path];
};

const getPaymentTypeAnalyticsString = (isScheduled, formObj) => {
  const scheduledString = isScheduled ? 'scheduled:' : '';
  const { paymentMethodOption, instrument } = formObj;

  let method = 'token';

  if (paymentMethodOption === 'PaymentCard') {
    method = `card:${instrument.cardType}`;
  }

  if (paymentMethodOption === 'Bank') {
    method = `bank:${instrument.bankAccountType}`;
  }

  if (paymentMethodOption === 'Apple Pay') {
    method = 'applepay';
  }

  let tokenString;

  if (instrument) {
    tokenString = instrument.type === 'PaymentCard' ? `card:${instrument.cardType}` : `bank:${instrument.bankAccountType}`;
  }
  return `onetimepay:${scheduledString}${method === 'token' ? `${tokenString}:ewallet` : method}`.toLowerCase();
};

const getXmPaymentTypeAnalyticsString = (formObj) => {
  const instrument = formObj.paymentMethodOption || {};
  const paymentMethodOption = instrument.type || '';

  let method = 'token';

  if (paymentMethodOption === 'PaymentCard') {
    method = `card:${instrument.cardType}`;
  }

  let tokenString;

  if (instrument && instrument.type === 'PaymentCard') {
    tokenString = `card:${instrument.cardType}`;
  }

  return `onetimepay:${method === 'token' ? `${tokenString}:ewallet` : method}`.toLowerCase();
};

export const newPaymentTrackingPayload = (
  summary = {},
  savedPaymentMethods = [],
  showLateFeeCredit = false,
  billData = {},
  useBillData = false,
) => {
  let pageLoadEvent = 'payment start';

  const {
    balance: { balanceDue: billDataBalanceDue, pastDueBalance: billDataPastDue } = {},
  } = billData;
  const {
    balanceDue: billCurrentBalanceDue,
    pastDueBalanceRemaining: billCurrentPastDueBalanceRemaining,
  } = summary || {};
  const balanceDue = useBillData ? Number(billDataBalanceDue) || 0 : billCurrentBalanceDue;
  const pastDueBalanceRemaining = useBillData
    ? Number(billDataPastDue) || 0
    : billCurrentPastDueBalanceRemaining;

  // If user has saved payment instruments
  if (savedPaymentMethods.length) {
    pageLoadEvent += ', ewallet impression';
  }

  const component = [];

  const paymentAmountOptions = {};

  if (showLateFeeCredit) {
    component.push({
      placementName: 'myaccount|billing',
      componentName: 'late-fee-banner',
    });
  }

  if (balanceDue > 0.00) {
    paymentAmountOptions.balanceDue = balanceDue;
  }

  if (pastDueBalanceRemaining > 0.00) {
    paymentAmountOptions.pastDueBalanceRemaining = pastDueBalanceRemaining;
  }

  return {
    component,
    pageLoadEvent,
    transaction: 'single payment',
    trackName: 'c-tracking-log-page',
    deleteComponent: true,
    deleteEvents: true,
    attributes: {
      isBillPaymentStart: true,
      hasEwallet: !!savedPaymentMethods.length,
    },
    billPay: {
      paymentAmountOptions,
    },
  };
};

export const newArrangementTrackingPayload = (billData = {}) => {
  const {
    balance: { balanceDue: billDataBalanceDue, pastDueBalance: billDataPastDue } = {},
  } = billData;
  const balanceDue = Number(billDataBalanceDue) || 0;
  const pastDueBalanceRemaining = Number(billDataPastDue) || 0;

  const component = [];

  // User has to have balance and past due balance for payment arrangement to be available
  const paymentAmountOptions = billDataBalanceDue || billDataPastDue ? {
    balanceDue,
    pastDueBalanceRemaining,
  } : {};

  return {
    component,
    pageLoadEvent: 'payment start',
    transaction: 'single payment',
    trackName: 'c-tracking-log-page',
    deleteComponent: true,
    deleteEvents: true,
    attributes: {
      isBillPaymentStart: true, hasEwallet: false,
    },
    billPay: {
      paymentAmountOptions,
    },
  };
};

export const newPaymentReviewTrackingPayload = (
  reviewMessage = '',
  showLateFeeCredit = false,
) => {
  const component = [];

  if (reviewMessage.length) {
    component.push([{
      placementName: 'myaccount|billing',
      componentName: reviewMessage,
    }]);
  }

  // we don't show late fee credit banner on review anymore
  // this might not be needed?
  if (showLateFeeCredit) {
    component.push([{
      placementName: 'myaccount|billing',
      componentName: 'late-fee-banner',
    }]);
  }

  return {
    attributes: {
      isBillPaymentReview: true,
    },
    deleteComponent: true,
    component,
  };
};

export const newPaymentConfirmationTrackingPayload = (
  summary = {},
  formObj = {},
  showFlexPromo,
  peacockPromo = { show: false },
  billData = {},
  useBillData = false,
) => {
  const isScheduled = formObj.date && !getIsToday(formObj.date);
  const {
    balance: { balanceDue: billDataBalanceDue, pastDueBalance: billDataPastDue } = {},
  } = billData;
  const {
    balanceDue: billCurrentBalanceDue,
    pastDueBalanceRemaining: billCurrentPastDueBalanceRemaining,
  } = summary || {};
  const balanceDue = useBillData ? Number(billDataBalanceDue) || 0 : billCurrentBalanceDue;
  const pastDueBalanceRemaining = useBillData
    ? Number(billDataPastDue) || 0
    : billCurrentPastDueBalanceRemaining;
  const component = [];

  const attributes = { isBillPaymentConfirm: true };

  if (isScheduled) {
    attributes.isSinglePaymentScheduled = true;
  } else {
    attributes.isSinglePaymentToday = true;
  }

  const billPay = {
    paymentType: getPaymentTypeAnalyticsString(isScheduled, formObj),
    amount: formObj.amount,
    billingChannel: 'my account',
  };

  if (balanceDue) {
    billPay.amountDue = balanceDue;
    billPay.isTotalBalancePaid = balanceDue <= 0;
  }

  if (pastDueBalanceRemaining) {
    billPay.amountPastDueRemaining = pastDueBalanceRemaining;
  }

  if (showFlexPromo && !peacockPromo.show) {
    component.push({
      placementName: 'myaccount|billing|payment|confirm',
      componentName: 'flex-promo-banner',
    });
  }

  if (peacockPromo.show) {
    component.push({
      placementName: 'myaccount|offer',
      componentName: peacockPromo.scenario.l3Value,
    });
  }

  return {
    transaction: 'Single Payment',
    pageLoadEvent: `Single payment ${isScheduled ? 'scheduled' : 'today'}`,
    trackName: 'c-tracking-log-page',
    deleteComponent: true,
    deleteEvents: true,
    component,
    attributes,
    billPay,
  };
};

export const xmNewPaymentTrackingPayload = (
  balance,
  pastDueBalance,
) => {
  const paymentAmountOptions = {};

  if (balance > 0.00) {
    paymentAmountOptions.balance = balance;
  }

  if (pastDueBalance > 0.00) {
    paymentAmountOptions.pastDueBalanceRemaining = pastDueBalance;
  }

  return {
    component: [{
      placementName: 'myaccount|billing',
      componentName: 'xm-payment',
    }],
    pageLoadEvent: 'xm payment start',
    transaction: 'single payment',
    trackName: 'c-tracking-log-page',
    deleteComponent: true,
    deleteEvents: true,
    attributes: {
      isBillPaymentStart: true,
    },
    billPay: {
      paymentAmountOptions,
    },
  };
};

export const xmNewPaymentReviewTrackingPayload = () => ({
  component: [{
    placementName: 'myaccount|billing',
    componentName: 'xm-payment-review',
  }],
  pageLoadEvent: 'xm payment review',
  transaction: 'single payment',
  trackName: 'c-tracking-log-page',
  deleteComponent: true,
  deleteEvents: true,
  attributes: {
    isBillPaymentReview: true,
  },
});

export const xmNewPaymentConfirmationTrackingPayload = (
  balance,
  pastDueBalance,
  formObj = {},
) => {
  const billPay = {
    paymentType: getXmPaymentTypeAnalyticsString(formObj),
    amount: formObj.paymentAmountOption,
    billingChannel: 'my account',
  };

  if (balance) {
    billPay.amountDue = balance;
    billPay.isTotalBalancePaid = balance <= 0;
  }

  if (pastDueBalance) {
    billPay.amountPastDueRemaining = pastDueBalance;
  }

  return {
    component: [{
      placementName: 'myaccount|billing',
      componentName: 'xm-payment-confirm',
    }],
    pageLoadEvent: 'xm payment confirm',
    transaction: 'single payment',
    trackName: 'c-tracking-log-page',
    deleteComponent: true,
    deleteEvents: true,
    attributes: { isBillPaymentConfirm: true },
    billPay,
  };
};

export const xmNewPaymentBankTrackingPayload = () => ({
  trackName: 'c-tracking-log-page',
  component: [{
    placementName: 'myaccount|billing',
    componentName: 'xm-payment-new-bank',
  }],
});

export const xmNewPaymentCardTrackingPayload = () => ({
  trackName: 'c-tracking-log-page',
  component: [{
    placementName: 'myaccount|billing',
    componentName: 'xm-payment-new-card',
  }],
});

export const xmNewPaymentMethodTrackingPayload = () => ({
  trackName: 'c-tracking-log-page',
  component: [{
    placementName: 'myaccount|billing',
    componentName: 'xm-payment-new-method',
  }],
});

export const xmDeviceNewPaymentTrackingPayload = (
  balance,
) => {
  const paymentAmountOptions = {};

  if (balance > 0.00) {
    paymentAmountOptions.balance = balance;
  }

  return {
    component: [{
      placementName: 'myaccount|billing',
      componentName: 'xm-device-payment',
    }],
    pageLoadEvent: 'device payment start',
    transaction: 'single payment',
    trackName: 'c-tracking-log-page',
    deleteComponent: true,
    deleteEvents: true,
    attributes: {
      isXmDevicePaymentStart: true,
    },
    billPay: {
      paymentAmountOptions,
    },
  };
};

export const xmDeviceNewPaymentReviewTrackingPayload = () => ({
  component: [{
    placementName: 'myaccount|billing',
    componentName: 'xm-device-payment-review',
  }],
  pageLoadEvent: 'device payment review',
  transaction: 'single payment',
  trackName: 'c-tracking-log-page',
  deleteComponent: true,
  deleteEvents: true,
  attributes: {
    isXmDevicePaymentReview: true,
  },
});

export const xmDeviceNewPaymentConfirmationTrackingPayload = (
  balance,
  formObj = {},
) => {
  const billPay = {
    paymentType: getXmPaymentTypeAnalyticsString(formObj),
    amount: formObj.paymentAmountOption,
    billingChannel: 'my account',
  };

  if (balance) {
    billPay.amountDue = balance;
    billPay.isTotalBalancePaid = balance <= 0;
  }

  return {
    component: [{
      placementName: 'myaccount|billing',
      componentName: 'xm-device-payment-confirm',
    }],
    pageLoadEvent: 'device payment confirm',
    transaction: 'single payment',
    trackName: 'c-tracking-log-page',
    deleteComponent: true,
    deleteEvents: true,
    attributes: { isXmDevicePaymentConfirm: true },
    billPay,
  };
};

export const xmDeviceNewPaymentBankTrackingPayload = () => ({
  trackName: 'c-tracking-log-page',
  component: [{
    placementName: 'myaccount|billing',
    componentName: 'xm-device-payment-new-bank',
  }],
});

export const xmDeviceNewPaymentCardTrackingPayload = () => ({
  trackName: 'c-tracking-log-page',
  component: [{
    placementName: 'myaccount|billing',
    componentName: 'xm-device-payment-new-card',
  }],
});
export const xmDeviceNewPaymentMethodTrackingPayload = () => ({
  trackName: 'c-tracking-log-page',
  component: [{
    placementName: 'myaccount|billing',
    componentName: 'xm-device-payment-new-method',
  }],
});
